import { useMemo } from "react";
import useUser from "../../../hooks/useUser";

// Ownership check for editing a pet (the EDIT_PET permission is checked separately).
// Master can edit any pet, the owner can edit their own pet, and clinic staff can
// edit clinic-owned pets of their clinic, pets whose owner belongs to their clinic,
// or pets their owner connected to their clinic.
export default function useCanUserEditPet(pet) {
  const { currentClinic, roles, profile } = useUser();

  return useMemo(() => {
    if (roles.master) return true;

    if (pet?.userId && Number(pet?.userId) === Number(profile?.id)) return true;

    if (roles.adminOrEmployee) {
      if (!pet?.userId && Number(pet?.clinicId) === Number(currentClinic?.id))
        return true;

      if (
        pet?.ownerClinicId &&
        Number(pet?.ownerClinicId) === Number(currentClinic?.id)
      )
        return true;

      if (
        pet?.userId &&
        pet?.connectedClinicIds?.some(
          (clinicId) => Number(clinicId) === Number(currentClinic?.id),
        )
      )
        return true;
    }

    return false;
  }, [pet, roles, profile, currentClinic]);
}
